export default "__VITE_ASSET__ac55c097__"